<template>
<div class="chapter">
<div class="inner_page">
<div class="fig"><img alt="frontpiece1.jpg (77K)" class="c" src="Images/img001.jpg"/><br class="calibre2"/></div>
<div class="fig"><img alt="frontpiece2.jpg (82K)" class="c" src="Images/img002.jpg"/><br/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?e0767d62